module.exports = __webpack_public_path__ + "img/QQ.ca3a814b.jpg";